import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap5';

import BlockWithCheckbox from 'components/new_ui/Items/BlockWithCheckbox';

export default function Methods({ method, onChoose }) {
  return (
    <section>
      <Row>
        <BlockWithCheckbox
          key="manual"
          checkboxValue="manual"
          title="Input manually"
          description={(
            <>
              You can add members individually to your account.
              Simply select this option and click continue.
            </>
        )}
          className="col-lg-4 mb-3 align-self-stretch"
          checked={method === 'manual'}
          onChange={onChoose}
        />

        <BlockWithCheckbox
          key="hr-system"
          checkboxValue="hr-system"
          title="Connect to my HR System"
          description={(
            <>
              Use your login and password to connect directly to your
              company&apos;s HRIS platfrom. You can import your employee directory
              with a couple of easy steps.
            </>
        )}
          className="col-lg-4 mb-3 align-self-stretch"
          checked={method === 'hr-system'}
          onChange={onChoose}
        />

        <BlockWithCheckbox
          key="file"
          checkboxValue="file"
          title="I have a file on my computer"
          description={(
            <>
              Do you have a list of employees in an excel file available?
              Upload your file using our template to import your list quickly and accurately.
            </>
        )}
          className="col-lg-4 mb-3 align-self-stretch"
          checked={method === 'file'}
          onChange={onChoose}
        />
      </Row>
    </section>
  );
}

Methods.propTypes = {
  method: PropTypes.string,
  onChoose: PropTypes.func.isRequired,
};

Methods.defaultProps = {
  method: null,
};
